module.exports = __webpack_public_path__ + "img/exit3_b.9c49e749.svg";